import { read, write, unset } from './_db'

const root = 'session'
const key = 'user'

export default {
  set(value) {
    return write(root, key, value)
  },
  get() {
    return Object.assign({}, read(root, key))
  },
  clean() {
    return unset(root, key)
  },
}
